// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		if(document.getElementById('header').classList.contains('no-hero') || document.getElementById('gallery') || document.getElementById('attractions')){
			document.getElementById('header').classList.add('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
		} else{
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}
		
	};

	// Menus Live Text
	if(document.getElementsByClassName("menu-block")[0]){
		let menuCategories = document.querySelectorAll(".menu-block .menu-block__tabs .js-menu-tab");
		let menusSelector = document.getElementById("menusSelector");
		let ulMenu = document.querySelector(".menu-block ul");
		for(let c = 0; c < menuCategories.length; c++){
			menuCategories[c].addEventListener('click', function (e) {
				e.preventDefault();

				let currentCat = this.getAttribute("data-tag");
				document.querySelectorAll(".menu-block [data-tag]").forEach(item => { item.classList.remove('active'); })
				document.querySelectorAll(`.menu-block [data-tag="${currentCat}"] `).forEach(item => { item.classList.add('active'); })

				if(menusSelector){
					menusSelector.value = currentCat;
				}
				ulMenu.classList.remove("open");

			});
			menuCategories[0].click();
		}
		if(menusSelector){
			menusSelector.addEventListener('click', function () {
				ulMenu.classList.add("open");
			})
		}
	}


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	
	//// Forms animation for labels   ----------------------------------------------------------------
	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	// BURGER MENU NAVIGATION:

		// BURGUER MENU DESKTOP ----------------------------------------------------------------

		const menuBtn = document.getElementById('menu-btn');
		const navigation = document.querySelector('.navigation');
		const closeMenuBtn = document.querySelector('.js-close-menu');

		menuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.click();
			navigation.classList.add('open');
		});

		closeMenuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.remove('open');
		});

	// BURGUER MENU MOBILE ----------------------------------------------------------------

	const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
	const burgerMenuContainer = document.querySelector("#js-menuContainer")
	const closeMenu = document.querySelector(".js-burger-close");
	
	//Open Menu

	if(burgerMenuBtn){
		burgerMenuBtn.addEventListener('click', function (e) {
			e.preventDefault();
			burgerMenuContainer.classList.add("open");
			document.body.classList.add("no-scroll");
		});
	}
	
	if(closeMenu){
		closeMenu.addEventListener('click', () => {
			burgerMenuContainer.classList.remove("open");
			document.body.classList.remove("no-scroll");
		});
	}

	// SHOW SUBMENU FUNCTION: 

	const submenuToShow = (linksSelector, linkSubmenu) => {
		let navLinks = document.querySelectorAll(linksSelector); 
		let submenu_active = document.querySelectorAll(linkSubmenu); 

		navLinks.forEach(link => {
			const parent = link.parentNode;
			let submenu = parent.querySelector('.submenu');
			link.addEventListener('click', (e) => {
				link.classList.toggle('active');
				submenu.classList.toggle('active');
			});
			link.addEventListener('focus', (e) => {
				link.classList.toggle('active');
				submenu.classList.toggle('active');
			});
		});
		submenu_active.forEach(sub => {
			if (sub.classList.contains('active')) {
				if (window.screen.width > 640) {
					let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}else{
					let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}
			}

		})
	}

	if (window.screen.width > 640) {
		submenuToShow('#primary-nav li a', '.submenu li a');
	} else {
		submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
	}

	document.addEventListener('DOMContentLoaded', function() {
		const leftTitles = document.querySelectorAll('.accordion-rooms__left .item');
		const rightTitles = document.querySelectorAll('.accordion-rooms__right .js-accordion-rooms-title');
		const rightItem = document.querySelectorAll('.accordion-rooms__right .item');

		if(rightItem[0]){
			rightItem[0].classList.add('active');
		}
	

		function removeActiveClassFromRightTitles() {
			if (rightTitles.length > 0) {
				rightTitles.forEach(function(rightTitle) {
					rightTitle.classList.remove('active');
				});
			}
		}

		function setActiveToFirstRightTitle() {
			if (rightTitles.length > 0) {
				rightTitles[0].classList.add('active');
			}
		}

		function setActiveToFirstLeftTitle() {
			if (leftTitles.length > 0) {
				leftTitles[0].classList.add('active');
			}
		}

		function addActiveToClosestItem(element) {
			if (element) {
				const clickedItem = element.closest('.item');
				if (clickedItem) {
					const siblings = clickedItem.parentNode.querySelectorAll('.item');
					siblings.forEach(function(sibling) {
						if (sibling !== clickedItem) {
							sibling.classList.remove('active');
						}
					});
					clickedItem.classList.toggle('active');
				}
			}
		}

		setActiveToFirstRightTitle();
		setActiveToFirstLeftTitle();

		rightTitles.forEach(function(rightTitle, index) {
			rightTitle.addEventListener('click', function() {
				removeActiveClassFromRightTitles();

				const clickedIndex = index;

				rightTitle.classList.add('active');

				if (leftTitles.length > 0) {
					leftTitles.forEach(function(leftTitle) {
						leftTitle.classList.remove('active');
					});

					if (leftTitles[clickedIndex]) {
						leftTitles[clickedIndex].classList.add('active');
					}
				}

				addActiveToClosestItem(rightTitle);
			});
		});

	});

	// PARALLAX ANIMATION *****************************************************/

	const scrollParallax = {};

	const v_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

	function doParallax(elm) {
	let bounds = elm.dataset.parallax.split(",").map(Number);
	let distance = bounds[1] - bounds[0];
	let unit_scroll = distance / (v_height + elm.offsetHeight);

	let topElement = elm.getBoundingClientRect().top + window.pageYOffset;

	let beforeSpeed = parseFloat(elm.dataset.parallaxSpeedBefore) || 1.0;
	let afterSpeed = parseFloat(elm.dataset.parallaxSpeedAfter) || 1.0;

	let parallaxFunction = function () {
		let scrolled = window.pageYOffset;
		let relative_distance = scrolled + v_height - topElement;
		let temp = unit_scroll * relative_distance + bounds[0];

		elm.style.transform = `translate(0, ${temp}px)`;
	};

	scrollParallax[elm.dataset.parallaxid] = parallaxFunction;

	window.addEventListener('scroll', scrollParallax[elm.dataset.parallaxid]);
	}

	let observers_parallax_elements = document.querySelectorAll(".js-parallax-element");
	observers_parallax_elements.forEach((elm) => {
	doParallax(elm);
	});

	const options_parallax = {
	root: null,
	rootMargin: '0px',
	threshold: 0,
	};

	function handler_parallax(entries) {
		entries.forEach((entry) => {
			const target = entry.target;
			const id_elem = target.dataset.parallaxid;

			if (entry.isIntersecting) {
			doParallax(target);
			} else {
			window.removeEventListener('scroll', scrollParallax[id_elem]);
			}
		});
	}

	const observable_parallax = new IntersectionObserver(handler_parallax, options_parallax);
	let counter = 1;

	observers_parallax_elements.forEach((element) => {
	observable_parallax.observe(element);
	element.dataset.parallaxid = counter;
	counter++;
	});


})();




function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 60){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Function to modify Menu **/

document.addEventListener('DOMContentLoaded', () => {
	const skipSelectors = [
		'.privary-navigation__item a',
		'.secondary-navigation__item a',
		'.information span'
	];


	skipSelectors.forEach(selector => {
		const elements = document.querySelectorAll(selector);
		if (elements.length > 0) {
			elements.forEach(element => {
				element.setAttribute('tabindex', '-1');
			});
		}
	});
});

/** ADA Tab Links Functionality for Keyboard Navigation **/

const navigation = document.querySelector('.navigation');
const closeMenuButton = document.querySelector('.close-button');
const primaryMenuLinks = document.querySelectorAll('.privary-navigation__item a');
const secondaryMenuLinks = document.querySelectorAll('.information span');
const telMenuLinks = document.querySelectorAll('.information a');

function setTabIndex(value) {
    [closeMenuButton, ...primaryMenuLinks, ...secondaryMenuLinks, ...telMenuLinks]
        .filter(el => el)
        .forEach(el => el.setAttribute('tabindex', value));
}

document.addEventListener('focusin', function (event) {
    setTabIndex(navigation.classList.contains('open') || !navigation.contains(event.target) ? 0 : -1);
});

if (closeMenuButton) {
    closeMenuButton.addEventListener('click', () => {
        navigation.classList.add('open');
        setTabIndex(0);
    });
}

if (closeMenuButton) {
    closeMenuButton.addEventListener('click', () => {
        navigation.classList.remove('open');
        setTabIndex(-1);
    });
}






